import en from './en.json'
import fr from './fr.json'
import de from './de.json'

export const trainingLang = {en, fr, de}
